import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const ParcelTypesLarge: FC<SvgIconProps> = ({ viewBox = '0 0 254 170', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path d="M105.628 63.7103L206.833 45.5452L149.372 17L48.1666 35.1651L105.628 63.7103Z" fill="#FDDE84" />
    <path
      opacity="0.4"
      d="M80.7896 51.4766L181.995 33.3115L172.727 28.4922L71.151 46.6573L80.7896 51.4766Z"
      fill="#AA7B33"
    />
    <path d="M105.628 63.7103V154.907L48.1666 126.361V35.1651L105.628 63.7103Z" fill="#C39000" />
    <path opacity="0.4" d="M80.7896 51.4766V71.1246L71.151 65.9346V46.6573L80.7896 51.4766Z" fill="#AA7B33" />
    <path d="M105.628 63.7103V154.907L206.833 136.741V45.5452L105.628 63.7103Z" fill="#FCCE09" />
  </SvgIcon>
)
